<template>
    <div class="combination" :style="'padding: 0 ' + item.prConfig.val + 'px;margin-top:' + item.mbConfig.val +'px;'">
        <div class="combinationBox" :style="'background-color: ' + item.bgColor.color[0].item + ';'" :class="{'border-radius' : item.conStyle.type == 1}">
            <div class="title-box">
                <div class="left">
                    <div class="tag">
                        <span>团</span>
                    </div>
                    <div class="title">
                        <span>拼团活动</span>
                    </div>
<!--                    <div class="avatar-wrapper">-->
<!--                        <img src="@/components/decoration/static/mini-head1.png">-->
<!--                        <img src="@/components/decoration/static/mini-head2.png">-->
<!--                    </div>-->
<!--                    <span class="num">1234人拼团成功</span>-->
                </div>
                <span class="more">更多</span>
            </div>

            <template v-if="productgroupbuyList.length>0">
                <div class="product-detail">
                    <div class="product-item" v-for="(combinationItem,index) in productgroupbuyList" :key="index" :style="'margin-right: ' + item.lrConfig.val + 'px;'">
                        <img :src="combinationItem.product.productPic">
                        <div class="empty" v-if="item.joinShow.val">
                            <span>1234参与团</span>
                        </div>
                        <div class="product-name" v-if="item.titleShow.val">
                            <span>{{ combinationItem.product.productName }}</span>
                        </div>
                        <div class="product-price" :style="'color: ' + item.themeColor.color[0].item + ';'" v-if="item.priceShow.val">
                            <span>￥</span>
                            <span class="price">{{ combinationItem.groupbuyPrice }}</span>
                        </div>
                        <div class="bottom-text" :style="'background-color: ' + item.themeColor.color[0].item + ';'" v-if="item.bntShow.val">
                            <span>参与拼团</span>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="product-detail">
                    <div class="product-item" v-for="(combinationItem,index) in 3" :key="index" :style="'margin-right: ' + item.lrConfig.val + 'px;'">
                        <img src="@/components/decoration/static/not_img_product.png">
                        <div class="empty" v-if="item.joinShow.val">
                            <span>1234参与团</span>
                        </div>
                        <div class="product-name" v-if="item.titleShow.val">
                            <span>小米家用电饭煲，使用最好的材料打造</span>
                        </div>
                        <div class="product-price" :style="'color: ' + item.themeColor.color[0].item + ';'" v-if="item.priceShow.val">
                            <span>￥</span>
                            <span class="price">123</span>
                        </div>
                        <div class="bottom-text" :style="'background-color: ' + item.themeColor.color[0].item + ';'" v-if="item.bntShow.val">
                            <span>参与拼团</span>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { get } from '@/utils/request';

export default {
    props: {
        item: {
            type: Object,
            default: {}
        }
    },
    created() {
        this.getProductgroupbuyList();
    },
    data() {
        return {
            productgroupbuyList: [],
        };
    },
    methods:{
        // 获取平图案
        getProductgroupbuyList(){
            get("/shop/productgroupbuy/findList", {
                pageNum: 1,
                pageSize: 3
            }).then((res)=>{
                if(res.success){
                    this.productgroupbuyList = res.page.list
                }
            })
        }
    }
};
</script>

<style scoped lang="scss">
.combinationBox {
    width: 100%;
    padding: 10px 12px;
    background-color: #fff;
    overflow: hidden;

    .title-box{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left{
            display: flex;
            align-items: center;
            justify-content: left;

            .tag{
                width: 18px;
                height: 18px;
                font-size: 12px;
                color: #fff;
                border-radius: 3px;
                background-color: #ff5f5d;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .title{
                font-weight: 700;
                font-size: 16px;
                margin-left: 5px;
            }

            .avatar-wrapper{
                margin-left: 14px;
                display: flex;
                align-items: center;

                img{
                    width: 13px;
                    height: 13px;
                    border-radius: 50%;
                    border: 1px solid #fff;
                }

                :nth-child(2){
                    margin-left: -4px;
                }
            }

            .num{
                margin-left: 3px;
                color: #999;
                font-size: 13px;
            }
        }

        .more{
            font-size: 12px;
            color: #606266;
        }
    }

    .product-detail{
        width: 100%;
        margin-top: 10px;
        overflow: hidden;
        display: flex;

        .product-item{
            position: relative;
            flex-shrink: 0;
            width: 110px;
            height: 100%;
            border-radius: 7px;
            overflow: hidden;
            background-color: #fff;

            img{
                width: 110px;
                height: 110px;
            }

            .empty{
                position: absolute;
                top: 5px;
                left: 5px;
                width: 70px;
                height: 16px;
                color: #fff;
                font-size: 12px;
                background-color: #dadcde;
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;

                span{
                    transform: scale(.9);
                }
            }

            .product-name{
                padding: 5px 7px 0;
                font-size: 13px;
                line-height: 16px;
                text-overflow: ellipsis;
                overflow: hidden;
                word-break: break-all;
                white-space: nowrap;
            }

            .product-price{
                padding: 0 7px 5px;
                line-height: 16px;
                font-weight: 700;
                font-size: 12px;

                .price{
                    font-size: 16px;
                }
            }
            .bottom-text{
                width: 100%;
                height: 25px;
                font-size: 14px;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }
}

.border-radius{
    border-radius: 6px;
}
</style>